'use strict';

function Controller($i18next) {
	let $ctrl = this;

	$ctrl.cancelImport = function () {
		$ctrl.cancel();
	};

	$ctrl.confirmImport = function () {
		$ctrl.confirm();
	};

	$ctrl.parseDiff = function (diff, side) {
		const itemDiff = diff.item || diff;

		if (side === 'lhs') {
			if (typeof itemDiff.lhs === 'object') {
				return JSON.stringify(itemDiff.lhs, null, 2);
			}

			return itemDiff.lhs ?? 'undefined';
		}

		if (side === 'rhs') {
			// if itemDiff.rhs is an object, all object in beautiful way because it's going print in html
			if (typeof itemDiff.rhs === 'object') {
				return JSON.stringify(itemDiff.rhs, null, 2);
			}

			return itemDiff.rhs ?? 'undefined';
		}
	};

	$ctrl.$onInit = function () {
		$ctrl.filters = {
			all: {
				title: $i18next.t('general.all'),
				icon: 'fa-solid fa-folder-open',
				count:
					this.data.withValidationError.length +
					this.data.withChanges.length +
					this.data.newObjects.length +
					this.data.withNoChanges.length
			}
		};

		if ($ctrl.data.withValidationError.length > 0) {
			$ctrl.filters.errors = {
				title: $i18next.t('general.error', { count: $ctrl.data.withValidationError.length }),
				icon: 'fa-solid fa-exclamation-circle',
				count: this.data.withValidationError.length
			};
		}

		if ($ctrl.data.withChanges.length > 0) {
			$ctrl.filters.changes = {
				title: $i18next.t('general.changes'),
				icon: 'fa-solid fa-code-branch',
				count: this.data.withChanges.length
			};
		}

		if ($ctrl.data.newObjects.length > 0) {
			$ctrl.filters.new = {
				title: $i18next.t('general.new'),
				icon: 'fa-solid fa-star',
				count: this.data.newObjects.length
			};
		}

		if ($ctrl.data.withNoChanges.length > 0) {
			$ctrl.filters.unchanged = {
				title: $i18next.t('general.unchanged'),
				icon: 'fa-solid fa-clone',
				count: this.data.withNoChanges.length
			};
		}

		$ctrl.activeFilter = 'all';
	};
}

Controller.$inject = ['$i18next'];

angular.module('pmtPlacesApp.directives').component('pmtImportStatus', {
	templateUrl: 'components/import/pmtImportStatus.html',
	controller: Controller,
	bindings: {
		data: '<',
		cancel: '&',
		confirm: '&'
	}
});
